module.exports = __webpack_public_path__ + "static/Rajat-Arun-c229c100569f581299e56125e1217855.png";